import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import CustomNavbar from "./components/Navbar";
import SEOHelmet from "./components/SEOHelmet";
import useContent from "../data/useContent";
import pricesFallback from "../data/prices.json";
import teamFallback from "../data/team.json";

const round1 = (n) => parseFloat(n.toFixed(1));

// Preise kommen netto pro Stunde aus dem CMS, der Rest wird hier berechnet.
function toSupportItems(prices, team) {
  const vatFactor = 1 + prices.vat;
  return prices.groups.map((group) => ({
    id: group.id,
    title: group.title,
    price_h: round1(group.price_h),
    price_h_mwst: round1(group.price_h * vatFactor),
    price_15: round1(group.price_h / 4),
    price_15_mwst: round1((group.price_h / 4) * vatFactor),
    workers: group.employees
      .map((id) => team.employees.find((e) => e.id === id))
      .filter(Boolean),
  }));
}

function SupportGroup({ supportItem }) {
  return (
    <Card className="mb-4 shadow-lg border-0 rounded-4 overflow-hidden ">
      <Card.Body className="p-4">
        <Card.Title className="fs-3 fw-bold text-error">
          {supportItem.title}
        </Card.Title>
        <hr className="mb-3" />

        {/* Kompakte Preisdarstellung */}
        <Row className="mb-3">
          <Col md={6}>
            <div className="bg-light rounded-3 p-3 h-100">
              <div className="text-center">
                <div className="fs-6 text-muted mb-1">Pro Stunde</div>
                <div className="fs-4 fw-bold text-primary">
                  {supportItem.price_h_mwst}€
                </div>
                <div className="fs-6 text-muted">inkl. MwSt.</div>
                <div className="fs-6 fw-semibold">
                  {supportItem.price_h}€ exkl.
                </div>
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-light rounded-3 p-3 h-100">
              <div className="text-center">
                <div className="fs-6 text-muted mb-1">Pro 15 Min</div>
                <div className="fs-4 fw-bold text-success">
                  {supportItem.price_15_mwst}€
                </div>
                <div className="fs-6 text-muted">inkl. MwSt.</div>
                <div className="fs-6 fw-semibold">
                  {supportItem.price_15}€ exkl.
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {supportItem.workers && (
          <Row className="mt-4 justify-content-center">
            {supportItem.workers.map((worker) => (
              <Col
                xs={6}
                md={6}
                lg={6}
                xl={3}
                key={worker.id}
                className="d-flex justify-content-center mb-2"
              >
                <Card
                  className="border-0 text-center worker-card shadow-sm w-100"
                  style={{
                    width: "160px",
                    height: "160px",
                  }}
                >
                  <Card.Img
                    variant="top"
                    src={worker.img}
                    alt={worker.name}
                    loading="lazy"
                    className="rounded-circle mx-auto mt-2"
                    style={{
                      width: "90px",
                      height: "90px",
                      objectFit: "cover",
                      transition: "transform 0.3s ease-in-out",
                    }}
                  />
                  <Card.Body className="p-2">
                    <Card.Text className="fw-bold">{worker.name}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Card.Body>
    </Card>
  );
}

function Support() {
  const prices = useContent("prices", pricesFallback);
  const team = useContent("team", teamFallback);
  const support = prices && team ? toSupportItems(prices, team) : [];

  return (
    <div className={"pt-5"}>
      <SEOHelmet
        title="Fernwartung & IT-Support - Computer Center Lorentschitsch"
        description="Professionelle Fernwartung und IT-Support-Services von Computer Center Lorentschitsch. Schnelle Hilfe bei Computer-Problemen, Software-Installation und technischen Fragen."
        keywords="Fernwartung, IT-Support, Remote-Support, Computer-Hilfe, technischer Support, Software-Installation, Computer-Probleme, IT-Beratung, Lorentschitsch"
        canonical="https://lorentschitsch.at/fernwartung"
      />

      <CustomNavbar sameSite={false} />

      <Container className="py-5">
        <h1
          className="mb-4 text-center  text-error"
          style={{
            fontSize: "3rem",
          }}
        >
          Fernwartung
        </h1>
        <Row className="justify-content-center">
          {support.map((supportItem) => (
            <Col md={6} lg={6} key={supportItem.id}>
              <SupportGroup supportItem={supportItem} />
            </Col>
          ))}
        </Row>
        <Row className="mt-4">
          <Col className="d-flex justify-content-center">
            <a href="https://rd.lorentschitsch.at/download/ccl-support.exe" className="btn btn-success me-3 fs-1"
            style={{width: "200px"}}>
              Annehmen
            </a>
            <a
              href="/"
              className="btn btn-danger fs-1"
              style={{ width: "200px" }}
            >
              Ablehnen
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Support;
